import salesPolicyModal from '../BNO-RD3/salesPolicyModal';
export default salesPolicyModal;
